import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import { CarouselWrapper, LeftArrow, RightArrow, MobileBannerArrow } from './BasicCarousel.style'
import HeroBanner from '../HeroBanner'
import BannerArrows from '../Icons/BannerArrows'
import BannerArrowDown from '../Icons/BannerArrowDown'

const prevArrowBtn = (
  <LeftArrow>
    <span className="sr-only">Previous Slide</span>
    <svg viewBox="0 0 28 54"><BannerArrows /></svg>
  </LeftArrow>
)

const nextArrowBtn = (
  <RightArrow>
    <span className="sr-only">Next Slide</span>
    <svg viewBox="0 0 28 54"><BannerArrows /></svg>
  </RightArrow>
)

const scrollToSection = () => {
  let scrollTarget
  const childNodes = document.getElementsByClassName('main-content')[0].children
  // Load the third element in the main-content (first is the h1 screen title, second will be the basic carousel element)
  childNodes.length > 2 ? scrollTarget = childNodes[2] : scrollTarget = null
  if (scrollTarget) {
    window.scrollTo({
      top: scrollTarget.offsetTop - 60,
      behavior: 'smooth',
    })
  }
}

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: prevArrowBtn,
  nextArrow: nextArrowBtn,
}

const BasicCarousel = ({ fillScreen, carouselItems }) => (
  <CarouselWrapper fillScreen={fillScreen}>
    <Slider {...settings}>
      {
        carouselItems &&
        carouselItems.map(bannerContent => (
          <HeroBanner
            key={bannerContent.id}
            isCarousel
            fillScreen={fillScreen}
            {...bannerContent}
          />
        ))
      }
    </Slider>
    <MobileBannerArrow viewBox="0 0 42 15" onClick={scrollToSection}>
      <BannerArrowDown />
    </MobileBannerArrow>
  </CarouselWrapper>
)

BasicCarousel.propTypes = {
  title: PropTypes.string.isRequired,
  fillScreen: PropTypes.bool,
  carouselItems: PropTypes.shape({
    HeroBanner: PropTypes.object,
  }).isRequired,
}

BasicCarousel.defaultProps = {
  fillScreen: false,
}

export const BasicCarouselFragment = graphql`
  fragment BasicCarouselFragment on ContentfulBasicCarousel {
    title
    fillScreen
    carouselItems {
      ...HeroBannerFragment
    }
  }
`

export default BasicCarousel
